<script>
import Alert from '../Components/Alert.vue';
import WallMessageAlert from './WallMessageAlert.vue';
import alert from '../Components/Alert.vue';
import { getWallMessageInQueue } from '../Modules/WebSockets.js';
import { genericError } from '../Modules/Alerts.js';

export default {
  components: {
    WallMessageAlert,
    Alert,
  },

  data() {
    return {
      masterConfig: this.$page.props.master_config,
      user: this.$page.props.auth.user,
      toggles: this.$page.props.toggles,
      wss_url: this.$page.props.wss_url,
      wall_messages: {},
      reads: {},
      removedIDs: [],
    };
  },

  computed: {
    currentWallMessages() {
      let messages = {};

      Object.keys(this.wall_messages).forEach((key) => {
        let wall_message = this.wall_messages[key];
        let id = Number(wall_message.sk.replace('ID|', ''));
        let pk = wall_message.pk?.replace('WALL|', '');

        if (pk === 'ALLSHOPS' && parseInt(this.masterConfig.mode) === 6) {
          return;
        }

        if (
          wall_message.eventName !== undefined &&
          wall_message.eventName === 'REMOVE' &&
          !this.removedIDs.includes(id)
        ) {
          this.removedIDs.push(id);
        }

        if (Object.values(this.reads).indexOf(id) === -1 && this.removedIDs.indexOf(id) === -1) {
          messages[key] = wall_message;
        }
      });

      return messages;
    },

    latestWallMessage() {
      return Object.values(this.currentWallMessages)[0] ?? null;
    },
  },

  mounted() {
    getWallMessageInQueue(this.wss_url, this.masterConfig, this.user, this.toggles);
    this.pollWallMessages();
    this.getReadReceipts();
  },

  methods: {
    getReadReceipts() {
      axios
        .get(
          route('wall-messages.reads', {
            shop_id: this.masterConfig.shop_id,
          }),
        )
        .then((response) => {
          if (response.data?.data?.reads !== undefined) {
            this.reads = response.data.data.reads;
          }
        });
    },

    pollWallMessages() {
      this.wall_messages = window.wall_messages ?? [];
      setTimeout(() => {
        this.wall_messages = window.wall_messages ?? [];
        this.pollWallMessages();
      }, 3000);
    },

    readMessage(message_id, pk) {
      axios
        .post(
          route('wall-messages.read-message', {
            shop_id: this.masterConfig.shop_id,
            id: message_id,
          }),
        )
        .then((response) => {
          notyf.success('Message has been marked as read');
        })
        .catch((error) => {
          genericError();
        });
    },
  },
};
</script>

<template>
  <div v-if="latestWallMessage !== null" id="wall-message" class="mb-3">
    <WallMessageAlert
      v-if="latestWallMessage !== null"
      :id="latestWallMessage.sk"
      :pk="latestWallMessage.pk"
      :dismissable="true"
      icon="fa fa-comment"
      :message="latestWallMessage.message"
      @dismissed="readMessage"
    />
  </div>
</template>
